<template>
    <div id="labelsmallraampage">
        <div id="labelsmallraamcontent" v-if="products">
            <div class="error" v-if="products.length == 0">
                {{ trans('pages.label_small_window.no_product_details') }}
            </div>
            <template v-else>
                <div v-for="productDetails in products" id="labelsmallraam">
                    <p>
                        {{ productDetails.groupId }} {{ productDetails.place }}
                        {{ productDetails.customer }}
                    </p>
                    <p>
                        {{ productDetails.productId }}
                        {{ productDetails.name }} {{ productDetails.value }}
                    </p>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import labelApi from '../api/label';
import IdParamMixin from '../mixins/id-param';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    data() {
        return {
            products: null,
        };
    },
    mixins: [IdParamMixin(), localization],
    methods: {
        load() {
            labelApi
                .productLabelDetailsSmallWindow(this.idParam)
                .then((response) => {
                    this.products = response.data.data;
                })
                .catch(() => {
                    showErrorMessage(this.trans('pages.label_small_window.error_product_not_found'));
                });
        },
    },
};
</script>
